<svg:defs>
    <svg:polygon id="arrow"
                 points="30 10, 30 50, 10 50, 50 90, 90 50, 70 50, 70 10"/>
</svg:defs>
@for (move of orientations(); track $index) {
    <svg:use id="orientation-{{ move.landingOrientation }}"
             class="base mid-stroke semi-transparent"
             [ngClass]="getCurrentPlayerClass()"
             (click)="selectMove(move)"
             xlink:href="#arrow"
             [attr.transform]="getOrientationTransform(move.landingOrientation)"/>
}
